<template>
  <div class="m-stick-column" :style="elementStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'v-stick-column',
  props: {
    relativeElementSelector: {
      type: String,
      required: true,
    },
    pageClass: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      columnHeight: null,
      scrollElement: null,
      scrollTop: 0,
    };
  },
  mounted() {
    this.scrollElement = document.querySelector(`${this.pageClass}.router`);
    this.scrollElement.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    this.scrollElement.removeEventListener('scroll', this.onScroll);
  },
  computed: {
    relativeColumn() {
      return document.querySelector(this.relativeElementSelector);
    },
    elementStyle() {
      const { top } = this;
      let position = 'initial';
      let padding = '0px';
      if (this.scrollTop > 0) {
        position = 'fixed';
        padding = '15px';
      }
      return `position: ${position}; top: ${top}; padding-right: ${padding}`;
    },
  },
  methods: {
    onScroll() {
      this.scrollTop = this.scrollElement.scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.m-stick-column';

  #{$parent} {
    // padding: 0 $spacing-base;
  }

</style>
